<clx-popover [(visible)]="isVisible" height="auto" i18n-title="@@upgrade.config.title" title="Configure upgrade">
    <messages name="uprgadeMessage"></messages>
    <clx-form
        has="top-labels"
        [create]="send.bind(this)"
        test-id="upgrade.start-upgrade-window"
        [disableChangeChecking]="true"
        messageTarget="uprgadeMessage"
        editMode="create"
        [disableChangeChecking]="true"
    >
        <clx-row>
            <clx-label i18n="@@upgrade.config.label.schedule">Schedule</clx-label>
            <clx-datetime name="startTime" [(ngModel)]="now" [min]="now" type="datetime" test-id="upgrade.start-upgrade-window.starttime.input">
                <clx-validation type="datetime"></clx-validation>
                <clx-validation type="required"></clx-validation>
            </clx-datetime>
        </clx-row>
        <clx-row>
            <clx-label i18n="@@upgrade.config.label.download-timeout">Download timeout(minutes)</clx-label>
            <clx-input name="FileDownloadTimeout" type="number" [value]="60" test-id="upgrade.start-upgrade-window.file-download-timeout.input"></clx-input>
        </clx-row>
        <clx-row>
            <clx-label i18n="@@upgrade.config.label.application-shutdown">Application shutdown timeout(minutes)</clx-label>
            <clx-input name="ApplicationShutdownTimeout" type="number" [value]="30"  test-id="upgrade.start-upgrade-window.application-shutdown-timeout.input"></clx-input>
        </clx-row>
        <clx-row>
            <clx-label i18n="@@upgrade.config.label.retries">Retries</clx-label>
            <clx-input name="RetryCount" type="number" [value]="3" test-id="upgrade.start-upgrade-window.retry-count.input"></clx-input>
        </clx-row>
        <clx-row>
            <clx-label i18n="@@upgrade.config.label.notify">Notify</clx-label>
            <clx-input name="NotificationRecipients" [value]="notify" test-id="upgrade.start-upgrade-window.notify.input"></clx-input>
        </clx-row>
        <clx-row *ngIf="showMappingFile">
            <clx-label  i18n="@@upgrade.config.label.mapping">Mapping File</clx-label>
            <clx-custom-select name="mappingselect" #mappingSelect test-id="upgrade.start-upgrade-window.mapping.input">
                <mapping-window #mapping [selector]="mappingSelect" [data]="resource" [addCurrentEntry]="true" test-id="upgrade.start-upgrade-window.mapping-window"></mapping-window>
            </clx-custom-select>
        </clx-row>
        <clx-row>
            <clx-label  i18n="@@upgrade.config.label.parameter">Parameter</clx-label>
            <clx-custom-select name="parameterselect" #parameterSelect test-id="upgrade.start-upgrade-window.parameter.input">
                <parameter-window #parameter [selector]="parameterSelect" [data]="resource" [addCurrentEntry]="true" test-id="upgrade.start-upgrade-window.parameter-window"></parameter-window>
            </clx-custom-select>
        </clx-row>
        <clx-row>
            <clx-label  i18n="@@upgrade.config.label.bacnet">BACnet</clx-label>
            <clx-custom-select name="bacnetselect" #bacnetSelect test-id="upgrade.start-upgrade-window.bacnet-parameter.input">
                <bacnet-parameter-window #bacnetParameter [selector]="bacnetSelect" [data]="resource" [addCurrentEntry]="true" test-id="upgrade.start-upgrade-window.bacnet-parameter-window"></bacnet-parameter-window>
            </clx-custom-select>
        </clx-row>
        <clx-row>
            <clx-label i18n="@@upgrade.config.label.comment">Comment</clx-label>
            <clx-textarea name="Comment" test-id="upgrade.start-upgrade-window.comment.input"></clx-textarea>
        </clx-row>
        <clx-row type="buttons">
            <clx-button
                type="save"
                #savebutton
                i18n="@@upgrade.config.button.ok"
                test-id="upgrade.start-upgrade-window.save.button"
            >Ok</clx-button>
            <clx-button
                [ngClass]="enableUITwo ? 'button-reorder' : ''"
                (click)="close()"
                i18n="@@upgrade.config.button.cancel"
                test-id="upgrade.start-upgrade-window.cancel.button"
            >Cancel</clx-button>
        </clx-row>
    </clx-form>
</clx-popover>